// main/apps/admin/src/types/firestore.d.tsに定義されている
// firestore.d.tsのinterface EventTicket extends Model参照
export const TICKET_CLASS = {
  SPECIAL_BONUS_VENUE: 1,
  BONUS_VENUE: 2,
  VENUE: 3,
  LIVE_STREAM: 7,
  VOD_STREAM: 8,
} as const;
